<template lang="pug">
div
  app-divider(label="Dados do VTN", :showBorder="true")
    template(slot="actionButton")
      el-button(type="primary", @click="exportarPdf()")
        i.fal.fa-file-pdf
        span &nbsp Exportar PDF
  el-row.rowResumo
    el-col(:span="6")
      span.label Processo Nº: &nbsp
      span {{ dadosVtn.processoFisico.numero || '-' }}
    el-col(:span="6")
      span.label Município: &nbsp
      span {{ dadosVtn.processoFisico.endereco.municipio.nome || '-' }}
    el-col(:span="6")
      span.label Região: &nbsp
      span {{ dadosVtn.processoFisico.endereco.municipio.regiao || '-' }}
    el-col(:span="6")
      span.label Sr - Área requerida: &nbsp
      span {{ formatarNumero(dadosVtn.areaRequerida, 4) }} ha

  app-divider(label="IFa - Distância", :showBorder="true")
  el-row.rowResumo
    el-col(:span="12")
      span.label Fator de distância: &nbsp
      span {{ dadosVtn.fatorDistancia.descricao }}
    el-col(:span="12")
      span.label Índice: &nbsp
      span {{ dadosVtn.fatorDistancia.indice | formatDouble }}

  app-divider(label="IFb - Acesso à área", :showBorder="true")
  el-row.rowResumo
    el-col(:span="12")
      span.label Fator de acesso: &nbsp
      span {{ dadosVtn.fatorAcesso.descricao }}
    el-col(:span="12")
      span.label Índice: &nbsp
      span {{ dadosVtn.fatorAcesso.indice | formatDouble }}

  app-divider(label="IFc - Ancianidade da ocupação", :showBorder="true")
  el-row.rowResumo
    el-col(:span="12")
      span.label Fator de tempo de ocupação: &nbsp
      span {{ dadosVtn.fatorTempoOcupacao.descricao }}
    el-col(:span="12")
      span.label Índice: &nbsp
      span {{ dadosVtn.fatorTempoOcupacao.indice | formatDouble }}

  app-divider(label="IFd - Dimensão da área", :showBorder="true")
  el-row.rowResumo
    el-col(:span="6")
      span.label {{estado == 'pa' ? 'VRD' : 'VRT'}}: &nbsp
      span R$ {{ dadosVtn.calculosVtn.valorRegiao | formatDouble }}
    el-col(:span="6")
      span.label MF: &nbsp
      span {{ dadosVtn.calculosVtn.mf }} ha
    el-col(:span="6")
      span.label VTN/ha: &nbsp
      span R$ {{ dadosVtn.calculosVtn.vrt | formatDouble }}
    el-col(:span="6" v-if="estado != 'pa'")
      span.label Índice: &nbsp
      span {{ dadosVtn.calculosVtn.indiceArea  | formatDouble }}
  el-row.rowResumo
    el-col(:span="6")
      span.label Nº de MF: &nbsp
      span {{ dadosVtn.calculosVtn.numeroMf | formatDouble }}
    el-col(:span="6")
      span.label VTN: &nbsp
      span R$ {{ dadosVtn.calculosVtn.vtn | formatDouble }}

  app-divider(label="Taxa de ocupação", :showBorder="true")
  el-row.rowResumo
    el-col(:span="6")
      span.label Taxa de ocupação (ano): &nbsp
      span {{ dadosVtn.tempoOcupacao }}
    el-col(:span="6")
      span.label Porcentagem: &nbsp
      span {{ dadosVtn.calculosVtn.taxaOcupacaoPorcentagem | formatDouble}} %
    el-col(:span="6")
      span.label Valor da taxa: &nbsp
      span R$ {{ dadosVtn.calculosVtn.valorTaxaOcupacao | formatDouble }}

  // LISTAGEM DAS CUSTAS PROCESSUAIS SELECIONADAS
  div(v-if="dadosVtn.calculosVtn.resumoCustasProcessuais")
    app-divider(label="Custas processuais", :showBorder="true")
    .px-10
      el-table(
        :data="dadosVtn.calculosVtn.resumoCustasProcessuais"
      )
        el-table-column(label="Discriminação", prop="descricao", min-width="500")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasProcessuais.length - 1}") {{ scope.row.descricao }}
        el-table-column(label="Quantidade", prop="quantidade", min-width="150")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasProcessuais.length - 1}") {{ scope.row.quantidade }}
        el-table-column(label="Valor (R$)", prop="valor", min-width="250", align="right")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasProcessuais.length - 1 }") {{ scope.row.valor | formatDouble }}
        el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA", min-width="250", align="right")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasProcessuais.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

  // LISTAGEM DAS CUSTAS AGRÁRIAS SELECIONADAS
  div(v-if="dadosVtn.calculosVtn.resumoCustasAgrarias")
    app-divider(label="Custas agrárias", :showBorder="true")
    .px-10
      el-table(
        :data="dadosVtn.calculosVtn.resumoCustasAgrarias"
      )
        el-table-column(label="Discriminação", prop="descricao", min-width="500")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasAgrarias.length - 1}") {{ scope.row.descricao }}
        el-table-column(label="Quantidade", prop="quantidade", min-width="150")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasAgrarias.length - 1}") {{ scope.row.quantidade }}
        el-table-column(label="Valor", prop="valor", min-width="250", align="right")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasAgrarias.length - 1 }") R$ {{ scope.row.valor | formatDouble }}
        el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA", min-width="250", align="right")
          template(slot-scope="scope")
            span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoCustasAgrarias.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

  app-divider.mt-3(label="Dados do pagamento", :showBorder="true")
  .pad-10
    b Observações: &nbsp
    ul
      li {{msgCalculo()}}
      li {{msgReajuste()}}
      li(v-if="dadosVtn.respeitaLegislacaoAmbiental")
        span Respeita a legislação ambiental, preservando originariamente a reserva legal nos índices legalmente previstos
          |  e conservando a área de preservação permanente, com a devida apresentação pelo interessado da comprovação
          |  emitida pelo órgão ambiental (desconto de 30%).
      li(v-if="dadosVtn.temDireitoRegularizacao")
        span Tem direito a regularização fundiária através do regime especial de compra (desconto de 20%).

  // RESUMO DOS CÁLCULOS TOTAIS
  .px-10
    el-table.mt-3(
      v-if="dadosVtn && dadosVtn.calculosVtn && dadosVtn.calculosVtn.resumoVtn"
      :data="dadosVtn.calculosVtn.resumoVtn"
    )
      el-table-column(label="Resumo", prop="descricao")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1}") {{ scope.row.descricao }} &nbsp
          el-tooltip(v-if="scope.row.descricao === 'Custas agrárias'", effect='dark', :content='msgAgrarias', placement="right")
            i.fa.fa-question-circle
      el-table-column(label="Valor", prop="valor",  align="right")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") R$ {{scope.row.valor | formatDouble }}
      el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA",  align="right")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtn.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

  // RESUMO DOS CÁLCULOS TOTAIS COM DESCONTOS
  .px-10
    el-table.mt-3(
      v-if="dadosVtn.calculosVtn.resumoVtnComDesconto"
      :data="dadosVtn.calculosVtn.resumoVtnComDesconto"
    )
      el-table-column(label="Resumo com desconto", prop="descricao")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") {{ scope.row.descricao }} &nbsp
          el-tooltip(v-if="scope.row.descricao === 'Custas agrárias'", effect='dark', :content='msgAgrarias', placement="right")
            i.fa.fa-question-circle
      el-table-column(label="Valor", prop="valor", align="right")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") R$ {{ scope.row.valor | formatDouble }}
      el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA", align="right")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnComDesconto.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}

  // RESUMO DOS CÁLCULOS TOTAIS PARA PAGAMENTO PARCELADO
  .px-10
    el-table.mt-3(
      :data="dadosVtn.calculosVtn.resumoVtnParcelas",
      v-if="dadosVtn.formaPagamento === 'PARCELADO'"
    )
      el-table-column(label="Detalhamento das parcelas", prop="descricao")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") {{ scope.row.descricao }} &nbsp
          el-tooltip(v-if="scope.row.descricao === 'Custas agrárias'", effect='dark', :content='msgAgrarias', placement="right")
            i.fas.fa-question-circle
      el-table-column(label="Valor (R$)", prop="valor")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") R$ {{scope.row.valor | formatDouble }}
      el-table-column(label="Quantidade em UPFPA", prop="quantidadeUPFPA")
        template(slot-scope="scope")
          span(:class="{'label': scope.$index === dadosVtn.calculosVtn.resumoVtnParcelas.length - 1 }") {{ scope.row.quantidadeUPFPA | formatDouble }}
</template>

<script>
import AppDivider from '@/components/AppDivider'
import utils from '@/utils/utils'

export default {
  components: {
    AppDivider
  },

  data () {
    return {
      msgAgrarias: 'O valor das custas agrárias é a soma do "Valor da taxa de ocupação" + "Custas agrárias"',
      estado: process.env.ESTADO
    }
  },

  computed: {
    dadosVtn () {
      return this.$store.state.vtn.dadosVtn
    }
  },

  methods: {
    exportarPdf () {
      this.$store.dispatch('vtn/exportarPdf')
    },
    formatarNumero (val, precision) {
      return utils.format(val, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision })
    },
    msgCalculo () {
      switch (this.estado) {
        case 'pa':
          return 'Cálculos efetuados com base no DECRETO Nº 1.684, de 29 de JUNHO de 2021; Lei Estadual nº 8.878, de 8 de julho de 2019 e DECRETO Nº 1.190, DE 25 / 11 / 2020.'
        default:
          return 'Cálculos efetuados com base na Resolução da CEPAF nº 001, de 30/06/2015 e IN nº 001, de 08/05/2017.'
      }
    },
    msgReajuste () {
      switch (this.estado) {
        case 'pa':
          return 'Reajustado/Atualizado pela UPFPA do ano vigente, com juros de 4% ao ano para pessoas físicas e de 7,25% ao ano para pessoas jurídicas.'
        default:
          return 'Reajuste pela UPFPA do em vigor e juros de 4% ao ano.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.rowResumo {
  padding: 15px 0;
}

li {
  padding: 5px 0;
}

.label {
  font-weight: bold;
  padding-bottom: 10px;
}

.dados-processo {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.dado-item {
  display: flex;
  flex-wrap: wrap;
  width: 33%;
  padding: 10px 0;
}

.check {
  margin-right: 2%;
  display: inline-block;
}

.termo {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: $color-primary;
  border-color: $color-primary;
}

.mt-3 {
  margin-top: 3%;
}

.pad-10 {
  padding: 10px;
}

.px-10 {
  padding: 0 10px;
}

.divider {
  border-bottom: 1px solid
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/vtn/ResumoVtn.vue